import { useContext, useState, useEffect } from "react";
import { ChartContext } from "../../../Context/ChartContext/ChartContext";
import MainContext from "../../../Context/MainContext/MainContext";
import MUIVisibilityIcon from "@mui/icons-material/Visibility";
import Card from "../../Card";
import PdfAssistiveTechnologyReport from "../../../Utility/Pdf/PdfAssistiveTechnologyReport";

/**
 * Renders a PDF preview card. Generates a PDF based on the type prop and
 * displays it in an iframe. Also sets the generated file in chartContext for
 * upload.
 *
 * @param {Object} props
 * @param {string} props.type The type of PDF to generate (e.g.,
 * "assistive-technology-report").
 * @returns {JSX.Element}
 */
const className = "CardChartPreview";
const title = "Preview";
const icon = MUIVisibilityIcon;

export default function CardChartPreview(props) {
    const chartContext = useContext(ChartContext);
    const mainContext = useContext(MainContext);

    const type = props?.type || null;

    const [blobUrl, setBlobUrl] = useState(null);
    const [file, setFile] = useState(null);

    useEffect(() => {
        const generatePdf = async () => {
            let pdf;

            switch (type) {
                case "assistive-technology-report":
                    pdf = new PdfAssistiveTechnologyReport({ chartContext, mainContext }, {});
                    break;
            }

            await pdf.render();

            const blob = pdf.document.output('blob');
            const blobUrl = URL.createObjectURL(blob) + '#toolbar=0&navpanes=0&scrollbar=0';

            // Generate filename based on patient name
            const patient = chartContext.chart.patient[chartContext.patientId];
            const firstName = patient?.firstName || '';
            const lastName = patient?.lastName || '';
            const filename = `${firstName}-${lastName}_Assistive-Technology-Report.pdf`;

            setBlobUrl(blobUrl);
            setFile(new File([blob], filename, { type: 'application/pdf' }));
        };

        generatePdf();
    }, [chartContext.chart]);

    // Update the uploaded file in context after render (not during)
    useEffect(() => {
        if (file) {
            chartContext.setUploadedFile(file);
        }
    }, [file]);


    const renderContent = () => (
        <iframe
            src={blobUrl}
            style={{ width: '100%', height: props.isViewMode ? '70vh' : '450px', border: 'none' }}
            title="ATP Assessment Preview"
        />
    );

    return (
        <Card
            renderContent={renderContent}
            getTitle={() => title}

        />
    );
}

CardChartPreview.meta = { className: className, title: title, icon: icon };
